import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'what_is_the_construction_date_of_the_oldest_building_the_fac_oc'

export const dataPointDefinition = {
  retracedId: 'what_is_the_construction_date_of_the_oldest_building_the_fac_oc',
  name: 'What is the construction date of the oldest building the facility occupies? ',
  meta: {},
  fieldTypeId: 'DATE',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fp-bui-12',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 1010,
  sectionId: '2.2.6.3',
  impactArea: 'Building and Operating Licenses',
  impactAreaId: 'BUILDING_AND_OPERATING_LICENSES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
